const SET_STATUS = (state, status) => {
  state.status = status;
};

const SET_FETCHING_STATUS = (state, value) => {
  state.fetchingStatus = value;
};

export default {
  SET_STATUS,
  SET_FETCHING_STATUS,
};
